import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import {
  idToDate,
  orderRef,
  formatDate,
  itemCount,
  statusLabel,
  statusTone,
} from "./profileData";

/*
 * One table for both the dashboard (compact) and the history page (with
 * per-row actions). Every column is derived from the fields the order
 * endpoint actually projects.
 */
const OrdersTable = ({ orders, formatPrice, withActions }) => (
  <div className="c4prf__table-wrap">
    <table className="c4prf__table">
      <thead>
        <tr>
          <th scope="col">Order</th>
          <th scope="col">Date</th>
          <th scope="col">Items</th>
          <th scope="col">Total</th>
          <th scope="col">Status</th>
          {withActions ? (
            <th scope="col">
              <span className="c4prf__sr-only">Actions</span>
            </th>
          ) : null}
        </tr>
      </thead>

      <tbody>
        {orders.map((order) => {
          const count = itemCount(order);

          return (
            <tr key={order._id}>
              <td data-label="Order">
                <span className="c4prf__ref">{orderRef(order._id)}</span>
              </td>
              <td data-label="Date">{formatDate(idToDate(order._id))}</td>
              <td data-label="Items">
                {count} {count === 1 ? "item" : "items"}
              </td>
              <td data-label="Total">{formatPrice(order.overallTotal)}</td>
              <td data-label="Status">
                <span
                  className={`c4prf__pill c4prf__pill--${statusTone(order.status)}`}
                >
                  {statusLabel(order.status)}
                </span>
              </td>
              {withActions ? (
                <td data-label="Actions">
                  <span className="c4prf__row-actions">
                    <Link to={process.env.PUBLIC_URL + "/order-status"}>
                      Track
                    </Link>
                    <Link to={process.env.PUBLIC_URL + "/refund"}>Return</Link>
                  </span>
                </td>
              ) : null}
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>
);

OrdersTable.propTypes = {
  orders: PropTypes.array.isRequired,
  formatPrice: PropTypes.func.isRequired,
  withActions: PropTypes.bool,
};

export default OrdersTable;
